"use client";

import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

export default function CustomModal({ show, onClose }) {
  return (
    <Dialog open={show} onClose={onClose} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
          >
            <div>
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#1a2a6c]">
                <CheckIcon
                  aria-hidden="true"
                  className="h-6 w-6 text-[#ff6f61]"
                />
              </div>
              <div className="mt-3 text-center sm:mt-5">
                <DialogTitle
                  as="h3"
                  className="text-lg font-semibold leading-6 text-[#1a2a6c]"
                >
                  Bedankt voor je aanvraag{" "}
                  <span className="text-[#ff6f61]">aanvraag</span>
                </DialogTitle>
                <p className="mt-4 text-sm text-gray-600">
                  Wij hebben je offerteaanvraag goed ontvangen en gaan er meteen
                  mee aan de slag. Je krijgt van ons binnen de 24u een
                  bevestigingsmail met een overzicht van je aanvraag. Je hoort
                  snel van ons.
                </p>
                <p className="mt-4 text-sm text-gray-600">
                  Heb je ondertussen vragen? Neem gerust{" "}
                  <Link to="/contact" className="text-[#ff6f61] underline">
                    contact
                  </Link>{" "}
                  met ons op.
                </p>
              </div>
            </div>
            <div className="mt-5 sm:mt-6">
              <button
                type="button"
                onClick={onClose}
                className="inline-flex w-full justify-center rounded-md bg-[#1a2a6c] px-3 py-2 text-sm font-semibold text-[#ff6f61] shadow-sm hover:bg-[#142057] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1a2a6c]"
              >
                Terug naar home
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
